// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!../../../tailwind.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-btn-variant-solid {
  background: #1677ff !important;
}
.ant-btn-variant-solid:disabled,
.ant-btn-variant-solid.ant-btn-disabled {
  background: rgba(0, 0, 0, 0.04) !important;
}
.table-wrap .ant-spin-dot i {
  background-color: #8fb8c6 !important;
}
.main-page-wrap {
  display: flex;
  width: 100%;
  height: calc(100vh - 48px);
}
.main-page-wrap .left-wrap {
  width: 300px;
  height: 100%;
  margin-right: 10px;
}
.main-page-wrap .left-wrap .date_choose {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.main-page-wrap .right-wrap {
  width: calc(100% - 310px);
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main-page-wrap .ant-btn-variant-solid {
  background: #1677ff;
}
.main-page-wrap .right-top {
  width: 100%;
  height: calc(100% - 400px);
  overflow-y: scroll;
  border-left: 1px solid #000;
}
.main-page-wrap .right-top-wrap {
  flex-grow: 1;
}
.main-page-wrap .top-btn-wrap {
  width: 100%;
  height: 40px;
  background: #192234;
}
.main-page-wrap .ant-btn-primary {
  background: linear-gradient(to bottom, #4a5467 0, #4a5467 100%) !important;
}
.main-page-wrap .top-btn-wrap .ant-btn-primary {
  margin-left: 10px;
  margin-top: 4px;
}
.main-page-wrap .ant-form-item .ant-form-item-label > label {
  color: #fff;
}
.main-page-wrap .ant-form-item {
  margin: 15px 10px 15px 0;
}
.main-page-wrap .type_select .ant-form-item {
  margin: 0;
}
.main-page-wrap .ant-tabs .ant-tabs-tab {
  color: #fff;
  background: #3b3b3b;
}
.main-page-wrap .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab,
.main-page-wrap .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
  border-color: #000;
}
.main-page-wrap .ant-tabs-top > .ant-tabs-nav::before,
.main-page-wrap .ant-tabs-bottom > .ant-tabs-nav::before,
.main-page-wrap .ant-tabs-top > div > .ant-tabs-nav::before,
.main-page-wrap .ant-tabs-bottom > div > .ant-tabs-nav::before {
  border-bottom-color: #000;
}
.main-page-wrap .ant-tabs .ant-tabs-tab:hover {
  color: #fff;
}
.main-page-wrap .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active,
.main-page-wrap .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {
  background: linear-gradient(to bottom, #2e3440 0, #666 100%);
}
.main-page-wrap .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active,
.main-page-wrap .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab-active {
  border-bottom-color: transparent;
}
.main-page-wrap .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
}
.main-page-wrap .ant-tabs .ant-tabs-tab-btn:focus:not(:focus-visible),
.main-page-wrap .ant-tabs .ant-tabs-tab-remove:focus:not(:focus-visible),
.main-page-wrap .ant-tabs .ant-tabs-tab-btn:active,
.main-page-wrap .ant-tabs .ant-tabs-tab-remove:active {
  color: #fff;
}
.main-page-wrap .ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
  padding: 12px;
}
.main-page-wrap .ant-tabs-top > .ant-tabs-nav,
.main-page-wrap .ant-tabs-bottom > .ant-tabs-nav,
.main-page-wrap .ant-tabs-top > div > .ant-tabs-nav,
.main-page-wrap .ant-tabs-bottom > div > .ant-tabs-nav {
  margin: 0;
}
.main-page-wrap .ant-table {
  color: #fff !important;
  font-size: var(--custom-font-size);
  font-family: var(--custom-font-family);
  font-weight: 500;
  background: #2e3440;
}
.main-page-wrap .ant-table .ant-table-body {
  min-height: var(--scroll-y) !important;
}
.main-page-wrap .ant-table-column-title {
  color: #fff;
}
.main-page-wrap .ant-table-thead {
  background-color: #252930 !important;
}
.main-page-wrap .notShow {
  display: none;
}
.main-page-wrap .ant-table-wrapper .ant-table-cell,
.main-page-wrap .ant-table-wrapper .ant-table-thead > tr > th,
.main-page-wrap .ant-table-wrapper .ant-table-tbody > tr > th,
.main-page-wrap .ant-table-wrapper .ant-table-tbody > tr > td,
.main-page-wrap .ant-table-wrapper tfoot > tr > th,
.main-page-wrap .ant-table-wrapper tfoot > tr > td {
  padding: 8px;
}
.main-page-wrap .even-row {
  /* background: #4a5467; */
  background: #414651;
}
.main-page-wrap .odd-row {
  /* background: #3a4050; */
  background: #373e4c;
}
.main-page-wrap .selected-style {
  background: #84b9c8;
  color: #333;
}
.main-page-wrap .ant-table-row-selected:hover {
  background: #84b9c8;
}
.main-page-wrap .ant-table-wrapper .ant-table-thead > tr > th {
  background: #2e3440;
}
.main-page-wrap .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
  background: #2e3440;
}
.main-page-wrap .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td,
.main-page-wrap .ant-table-row-hover,
.main-page-wrap .ant-table-row-hover > td {
  background-color: #6e7585 !important;
}
.main-page-wrap .ant-table-fixed .ant-table-row-hover,
.main-page-wrap .ant-table-row-hover > td {
  background-color: #6e7585 !important;
}
.main-page-wrap .ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {
  background: #6e7585;
}
.main-page-wrap .ant-table-wrapper td.ant-table-column-sort,
.main-page-wrap .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
  background: transparent;
}
.main-page-wrap .ant-table .ant-table-border {
  border-color: 1px dotted #222 !important;
}
.main-page-wrap .ant-table .ant-table-tbody > tr > td {
  border-width: 0 1px 1px 0;
  border-style: dotted;
  border-color: #222 !important;
}
.main-page-wrap .ant-table {
  height: calc(100vh - 350px);
  background: #2e3440;
  /* font-weight: 500; */
}
.main-page-wrap .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder:hover > th,
.main-page-wrap .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder:hover > td,
.main-page-wrap .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder {
  background: #2e3440;
}
.main-page-wrap .ant-table-wrapper table {
  border-radius: 0;
}
.main-page-wrap .ant-table-wrapper .ant-table {
  background: #2e3440;
  border: 1px solid #000;
}
.main-page-wrap .ant-table-wrapper .ant-table-thead > tr > th,
.main-page-wrap .ant-table-wrapper .ant-table-thead > tr > td {
  border-bottom-color: #222;
}
.main-page-wrap .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td,
.main-page-wrap .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th,
.main-page-wrap .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th,
.main-page-wrap .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td {
  border-right: 1px dotted #222 !important;
}
.main-page-wrap .ant-table-wrapper .ant-table-cell-scrollbar:not([rowspan]) {
  box-shadow: 0 1px 0 1px #222;
}
.main-page-wrap .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container {
  border-inline-start: 1px solid #222;
  border-top: 1px solid #222;
  border-left: 1px solid #222;
}
.main-page-wrap .ant-table-thead > tr > th,
.main-page-wrap .ant-table-tbody > tr > td {
  border-radius: 0 !important;
}
.main-page-wrap .ant-table-wrapper .ant-table-cell-fix-right {
  background: #474747;
}
.main-page-wrap .ant-table-wrapper .ant-table-thead > tr > th {
  color: #fff;
}
.main-page-wrap .ant-input-outlined,
.main-page-wrap .ant-picker-outlined,
.main-page-wrap .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  background: #596172;
  border-color: #444;
  color: #fff;
}
.main-page-wrap .ant-input-outlined:focus,
.main-page-wrap .ant-input-outlined:focus-within,
.main-page-wrap .ant-picker-outlined:focus,
.main-page-wrap .ant-picker-outlined:focus-within {
  background: #596172;
  border-color: #444;
  color: #fff;
}
.main-page-wrap .ant-input-outlined:hover,
.main-page-wrap .ant-picker-outlined:hover {
  background: #596172;
}
.main-page-wrap .ant-table-wrapper .ant-table-column-sorter-up.active,
.main-page-wrap .ant-table-wrapper .ant-table-column-sorter-down.active {
  color: #84b9c8;
}
.main-page-wrap .ant-table-wrapper .ant-table-column-sorter-inner {
  color: #666;
}
.main-page-wrap .ant-picker .ant-picker-input > input::placeholder {
  color: #b6bcca !important;
}
.main-page-wrap .ant-select-selection-placeholder {
  color: #b6bcca !important;
}
.main-page-wrap .ant-table-wrapper .ant-table-pagination.ant-pagination {
  position: absolute;
  bottom: 0;
  right: 5px;
}
.main-page-wrap .ant-pagination-total-text {
  color: #fff;
}
.main-page-wrap .ant-pagination .ant-pagination-item-active {
  background-color: #84b9c8;
  border-color: #84b9c8;
}
.main-page-wrap .ant-pagination .ant-pagination-item:not(.ant-pagination-item-active):hover {
  background-color: #84b9c8;
  border-color: #84b9c8;
}
.main-page-wrap .ant-pagination .ant-pagination-next button,
.main-page-wrap .ant-pagination .ant-pagination-prev .ant-pagination-item-link {
  color: #f5f5f5;
}
.main-page-wrap .ant-pagination .ant-pagination-disabled .ant-pagination-item-link,
.main-page-wrap .ant-pagination .ant-pagination-disabled:hover .ant-pagination-item-link {
  color: #666;
}
.main-page-wrap .ant-pagination .ant-pagination-item-active a {
  color: #333;
}
.main-page-wrap .right-bottom-wrap .report_message {
  color: #fff;
  font-size: 16px;
  height: 220px;
  overflow-y: scroll;
  border: 1px solid #000;
  border-bottom: 1px solid transparent;
}
.main-page-wrap .right-bottom-wrap .report_message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 15px !important;
  background: #2b313c !important;
  cursor: pointer !important;
}
.main-page-wrap .right-bottom-wrap .report_message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  background: #20252d;
  border: 3px solid transparent;
}
.main-page-wrap .right-bottom-wrap .report_message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: 0 1px 0 1px #222 !important;
  border-radius: 0 !important;
  background: #2b313c !important;
  cursor: pointer !important;
  padding: 3px;
}
.main-page-wrap .right-bottom-wrap .report_message h3 {
  padding: 5px;
  color: orange;
  background: #414651;
}
.main-page-wrap .right-bottom-wrap .report_message p {
  padding: 5px 0;
  min-height: 30px;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/StudyListPage/components/MainPage.less"],"names":[],"mappings":"AAEA;EACE,8BAAA;AAAF;AAGA;;EAEE,0CAAA;AADF;AAIA;EACE,oCAAA;AAFF;AAKA;EACE,aAAA;EACA,WAAA;EACA,0BAAA;AAHF;AAAA;EAMI,YAAA;EACA,YAAA;EACA,kBAAA;AAHJ;AALA;EAWM,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAHN;AAXA;EAmBI,yBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AALJ;AAjBA;EA0BI,mBAAA;AANJ;AApBA;EA8BI,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;AAPJ;AA1BA;EAqCI,YAAA;AARJ;AA7BA;EAyCI,WAAA;EACA,YAAA;EACA,mBAAA;AATJ;AAlCA;EA+CI,0EAAA;AAVJ;AArCA;EAmDI,iBAAA;EACA,eAAA;AAXJ;AAzCA;EAwDI,WAAA;AAZJ;AA5CA;EA4DI,wBAAA;AAbJ;AA/CA;EAiEM,SAAA;AAfN;AAlDA;EAsEI,WAAA;EACA,mBAAA;AAjBJ;AAtDA;;EA6EI,kBAAA;AAnBJ;AA1DA;;;;EAoFI,yBAAA;AApBJ;AAhEA;EAwFI,WAAA;AArBJ;AAnEA;;EA6FI,4DAAA;AAtBJ;AAvEA;;EAmGI,gCAAA;AAxBJ;AA3EA;EAuGI,WAAA;AAzBJ;AA9EA;;;;EA8GI,WAAA;AA1BJ;AApFA;EAkHI,aAAA;AA3BJ;AAvFA;;;;EAyHI,SAAA;AA5BJ;AA7FA;EA6HI,sBAAA;EACA,kCAAA;EACA,sCAAA;EACA,gBAAA;EACA,mBAAA;AA7BJ;AApGA;EAoIM,sCAAA;AA7BN;AAvGA;EAyII,WAAA;AA/BJ;AA1GA;EA6II,oCAAA;AAhCJ;AA7GA;EAiJI,aAAA;AAjCJ;AAhHA;;;;;;EA0JI,YAAA;AAlCJ;AAxHA;EA0HE,yBAAyB;EAqCvB,mBAAA;AAnCJ;AA5HA;EA8HE,yBAAyB;EAsCvB,mBAAA;AApCJ;AAhIA;EAwKI,mBAAA;EACA,WAAA;AArCJ;AApIA;EA6KI,mBAAA;AAtCJ;AAvIA;EAiLI,mBAAA;AAvCJ;AA1IA;EAqLI,mBAAA;AAxCJ;AA7IA;;;EA2LI,oCAAA;AAzCJ;AAlJA;;EAgMI,oCAAA;AA1CJ;AAtJA;EAoMI,mBAAA;AA3CJ;AAzJA;;EAyMI,uBAAA;AA5CJ;AA7JA;EA8MI,wCAAA;AA9CJ;AAhKA;EAkNI,yBAAA;EACA,oBAAA;EACA,6BAAA;AA/CJ;AArKA;EAwNI,2BAAA;EACA,mBAAA;EAhDF,sBAAsB;AACxB;AA1KA;;;EAgOI,mBAAA;AAjDJ;AA/KA;EAoOI,gBAAA;AAlDJ;AAlLA;EAwOI,mBAAA;EACA,sBAAA;AAnDJ;AAtLA;;EA8OI,yBAAA;AApDJ;AA1LA;;;;EAqPI,wCAAA;AArDJ;AAhMA;EAyPI,4BAAA;AAtDJ;AAnMA;EA6PI,mCAAA;EACA,0BAAA;EACA,2BAAA;AAvDJ;AAxMA;;EAoQI,2BAAA;AAxDJ;AA5MA;EAwQI,mBAAA;AAzDJ;AA/MA;EA4QI,WAAA;AA1DJ;AAlNA;;;EAmRI,mBAAA;EACA,kBAAA;EACA,WAAA;AA5DJ;AAzNA;;;;EA4RI,mBAAA;EACA,kBAAA;EACA,WAAA;AA7DJ;AAjOA;;EAmSI,mBAAA;AA9DJ;AArOA;;EAwSI,cAAA;AA/DJ;AAzOA;EA4SI,WAAA;AAhEJ;AA5OA;EAgTI,yBAAA;AAjEJ;AA/OA;EAoTI,yBAAA;AAlEJ;AAlPA;EAwTI,kBAAA;EACA,SAAA;EACA,UAAA;AAnEJ;AAvPA;EA8TI,WAAA;AApEJ;AA1PA;EAkUI,yBAAA;EACA,qBAAA;AArEJ;AA9PA;EAuUI,yBAAA;EACA,qBAAA;AAtEJ;AAlQA;;EA6UI,cAAA;AAvEJ;AAtQA;;EAkVI,WAAA;AAxEJ;AA1QA;EAsVI,WAAA;AAzEJ;AA7QA;EA6VM,WAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,oCAAA;AA7EN;AA+EM;EA7EJ,UAAU;EA+EJ,sBAAA;EAGA,8BAAA;EACA,0BAAA;AA/ER;AAmFM;EAjFJ,WAAW;EAmFL,mBAAA;EACA,6BAAA;AAjFR;AAoFM;EAlFJ,UAAU;EAoFJ,+CAAA;EACA,2BAAA;EAEA,8BAAA;EACA,0BAAA;EACA,YAAA;AAnFR;AAxSA;EA+XQ,YAAA;EACA,aAAA;EACA,mBAAA;AApFR;AA7SA;EAqYQ,cAAA;EACA,gBAAA;AArFR","sourcesContent":["@import url('../../../tailwind.css');\n\n.ant-btn-variant-solid {\n  background: #1677ff !important;\n}\n\n.ant-btn-variant-solid:disabled,\n.ant-btn-variant-solid.ant-btn-disabled {\n  background: rgba(0, 0, 0, 0.04) !important;\n}\n\n.table-wrap .ant-spin-dot i {\n  background-color: #8fb8c6 !important;\n}\n\n.main-page-wrap {\n  display: flex;\n  width: 100%;\n  height: calc(100vh - 48px);\n\n  .left-wrap {\n    width: 300px;\n    height: 100%;\n    margin-right: 10px;\n\n    .date_choose {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-around;\n    }\n  }\n\n  .right-wrap {\n    width: calc(100% - 310px);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .ant-btn-variant-solid {\n    background: #1677ff;\n  }\n\n  .right-top {\n    width: 100%;\n    height: calc(100% - 400px);\n    overflow-y: scroll;\n    border-left: 1px solid #000;\n  }\n\n  .right-top-wrap {\n    flex-grow: 1;\n  }\n\n  .top-btn-wrap {\n    width: 100%;\n    height: 40px;\n    background: #192234;\n  }\n\n  .ant-btn-primary {\n    background: linear-gradient(to bottom, #4a5467 0, #4a5467 100%) !important;\n  }\n\n  .top-btn-wrap .ant-btn-primary {\n    margin-left: 10px;\n    margin-top: 4px;\n  }\n\n  .ant-form-item .ant-form-item-label>label {\n    color: #fff;\n  }\n\n  .ant-form-item {\n    margin: 15px 10px 15px 0;\n  }\n\n  .type_select {\n    .ant-form-item {\n      margin: 0;\n    }\n  }\n\n  .ant-tabs .ant-tabs-tab {\n    color: #fff;\n    background: #3b3b3b;\n\n  }\n\n  .ant-tabs-card>.ant-tabs-nav .ant-tabs-tab,\n  .ant-tabs-card>div>.ant-tabs-nav .ant-tabs-tab {\n    border-color: #000;\n  }\n\n  .ant-tabs-top>.ant-tabs-nav::before,\n  .ant-tabs-bottom>.ant-tabs-nav::before,\n  .ant-tabs-top>div>.ant-tabs-nav::before,\n  .ant-tabs-bottom>div>.ant-tabs-nav::before {\n    border-bottom-color: #000;\n  }\n\n  .ant-tabs .ant-tabs-tab:hover {\n    color: #fff;\n  }\n\n  .ant-tabs-card>.ant-tabs-nav .ant-tabs-tab-active,\n  .ant-tabs-card>div>.ant-tabs-nav .ant-tabs-tab-active {\n    background: linear-gradient(to bottom, #2e3440 0, #666 100%);\n    // background:#84b9c8;\n  }\n\n  .ant-tabs-card.ant-tabs-top>.ant-tabs-nav .ant-tabs-tab-active,\n  .ant-tabs-card.ant-tabs-top>div>.ant-tabs-nav .ant-tabs-tab-active {\n    border-bottom-color: transparent;\n  }\n\n  .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: #fff;\n  }\n\n  .ant-tabs .ant-tabs-tab-btn:focus:not(:focus-visible),\n  .ant-tabs .ant-tabs-tab-remove:focus:not(:focus-visible),\n  .ant-tabs .ant-tabs-tab-btn:active,\n  .ant-tabs .ant-tabs-tab-remove:active {\n    color: #fff;\n  }\n\n  .ant-tabs-card.ant-tabs-small>.ant-tabs-nav .ant-tabs-tab {\n    padding: 12px;\n  }\n\n  .ant-tabs-top>.ant-tabs-nav,\n  .ant-tabs-bottom>.ant-tabs-nav,\n  .ant-tabs-top>div>.ant-tabs-nav,\n  .ant-tabs-bottom>div>.ant-tabs-nav {\n    margin: 0;\n  }\n\n  .ant-table {\n    color: #fff !important;\n    font-size: var(--custom-font-size);\n    font-family: var(--custom-font-family);\n    font-weight: 500;\n    background: #2e3440;\n\n    .ant-table-body {\n      min-height: var(--scroll-y) !important;\n    }\n  }\n\n  .ant-table-column-title {\n    color: #fff;\n  }\n\n  .ant-table-thead {\n    background-color: #252930 !important;\n  }\n\n  .notShow {\n    display: none;\n  }\n\n  .ant-table-wrapper .ant-table-cell,\n  .ant-table-wrapper .ant-table-thead>tr>th,\n  .ant-table-wrapper .ant-table-tbody>tr>th,\n  .ant-table-wrapper .ant-table-tbody>tr>td,\n  .ant-table-wrapper tfoot>tr>th,\n  .ant-table-wrapper tfoot>tr>td {\n    padding: 8px;\n  }\n\n  .even-row {\n    /* background: #4a5467; */\n    background: #414651;\n  }\n\n  .odd-row {\n    /* background: #3a4050; */\n    background: #373e4c;\n  }\n\n  .selected-style {\n    background: #84b9c8;\n    color: #333;\n  }\n\n  .ant-table-row-selected:hover {\n    background: #84b9c8;\n  }\n\n  .ant-table-wrapper .ant-table-thead>tr>th {\n    background: #2e3440;\n  }\n\n  .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {\n    background: #2e3440;\n  }\n\n  .ant-table-tbody>tr:hover:not(.ant-table-expanded-row)>td,\n  .ant-table-row-hover,\n  .ant-table-row-hover>td {\n    background-color: #6e7585 !important;\n  }\n\n  .ant-table-fixed .ant-table-row-hover,\n  .ant-table-row-hover>td {\n    background-color: #6e7585 !important;\n  }\n\n  .ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {\n    background: #6e7585;\n  }\n\n  .ant-table-wrapper td.ant-table-column-sort,\n  .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {\n    background: transparent;\n  }\n\n\n  .ant-table .ant-table-border {\n    border-color: 1px dotted #222 !important;\n  }\n\n  .ant-table .ant-table-tbody>tr>td {\n    border-width: 0 1px 1px 0;\n    border-style: dotted;\n    border-color: #222 !important;\n  }\n\n  .ant-table {\n    height: calc(100vh - 350px);\n    background: #2e3440;\n    /* font-weight: 500; */\n  }\n\n  .ant-table-wrapper .ant-table-tbody>tr.ant-table-placeholder:hover>th,\n  .ant-table-wrapper .ant-table-tbody>tr.ant-table-placeholder:hover>td,\n  .ant-table-wrapper .ant-table-tbody>tr.ant-table-placeholder {\n    background: #2e3440;\n  }\n\n  .ant-table-wrapper table {\n    border-radius: 0;\n  }\n\n  .ant-table-wrapper .ant-table {\n    background: #2e3440;\n    border: 1px solid #000;\n  }\n\n  .ant-table-wrapper .ant-table-thead>tr>th,\n  .ant-table-wrapper .ant-table-thead>tr>td {\n    border-bottom-color: #222;\n  }\n\n  .ant-table-wrapper .ant-table.ant-table-bordered>.ant-table-container>.ant-table-content>table>tbody>tr>td,\n  .ant-table-wrapper .ant-table.ant-table-bordered>.ant-table-container>.ant-table-content>table>thead>tr>th,\n  .ant-table-wrapper .ant-table.ant-table-bordered>.ant-table-container>.ant-table-header>table>thead>tr>th,\n  .ant-table-wrapper .ant-table.ant-table-bordered>.ant-table-container>.ant-table-body>table>tbody>tr>td {\n    border-right: 1px dotted #222 !important;\n  }\n\n  .ant-table-wrapper .ant-table-cell-scrollbar:not([rowspan]) {\n    box-shadow: 0 1px 0 1px #222;\n  }\n\n  .ant-table-wrapper .ant-table.ant-table-bordered>.ant-table-container {\n    border-inline-start: 1px solid #222;\n    border-top: 1px solid #222;\n    border-left: 1px solid #222;\n  }\n\n  .ant-table-thead>tr>th,\n  .ant-table-tbody>tr>td {\n    border-radius: 0 !important;\n  }\n\n  .ant-table-wrapper .ant-table-cell-fix-right {\n    background: #474747;\n  }\n\n  .ant-table-wrapper .ant-table-thead>tr>th {\n    color: #fff;\n  }\n\n\n  .ant-input-outlined,\n  .ant-picker-outlined,\n  .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {\n    background: #596172;\n    border-color: #444;\n    color: #fff;\n  }\n\n  .ant-input-outlined:focus,\n  .ant-input-outlined:focus-within,\n  .ant-picker-outlined:focus,\n  .ant-picker-outlined:focus-within {\n    background: #596172;\n    border-color: #444;\n    color: #fff;\n  }\n\n  .ant-input-outlined:hover,\n  .ant-picker-outlined:hover {\n    background: #596172;\n  }\n\n  .ant-table-wrapper .ant-table-column-sorter-up.active,\n  .ant-table-wrapper .ant-table-column-sorter-down.active {\n    color: #84b9c8;\n  }\n\n  .ant-table-wrapper .ant-table-column-sorter-inner {\n    color: #666;\n  }\n\n  .ant-picker .ant-picker-input>input::placeholder {\n    color: #b6bcca !important;\n  }\n\n  .ant-select-selection-placeholder {\n    color: #b6bcca !important;\n  }\n\n  .ant-table-wrapper .ant-table-pagination.ant-pagination {\n    position: absolute;\n    bottom: 0;\n    right: 5px;\n  }\n\n  .ant-pagination-total-text {\n    color: #fff;\n  }\n\n  .ant-pagination .ant-pagination-item-active {\n    background-color: #84b9c8;\n    border-color: #84b9c8;\n  }\n\n  .ant-pagination .ant-pagination-item:not(.ant-pagination-item-active):hover {\n    background-color: #84b9c8;\n    border-color: #84b9c8;\n  }\n\n  .ant-pagination .ant-pagination-next button,\n  .ant-pagination .ant-pagination-prev .ant-pagination-item-link {\n    color: #f5f5f5;\n  }\n\n  .ant-pagination .ant-pagination-disabled .ant-pagination-item-link,\n  .ant-pagination .ant-pagination-disabled:hover .ant-pagination-item-link {\n    color: #666;\n  }\n\n  .ant-pagination .ant-pagination-item-active a {\n    color: #333;\n  }\n\n  .right-bottom-wrap {\n    // height: 500px;\n\n    .report_message {\n      color: #fff;\n      font-size: 16px;\n      height: 220px;\n      overflow-y: scroll;\n      border: 1px solid #000;\n      border-bottom: 1px solid transparent;\n\n      &::-webkit-scrollbar {\n        /*滚动条整体样式*/\n        width: 15px !important;\n        // /*高宽分别对应横竖滚动条的尺寸*/\n        // height: 6px !important;\n        background: #2b313c !important;\n        cursor: pointer !important;\n\n      }\n\n      &::-webkit-scrollbar-thumb {\n        /*滚动条里面小方块*/\n        background: #20252d;\n        border: 3px solid transparent;\n      }\n\n      &::-webkit-scrollbar-track {\n        /*滚动条里面轨道*/\n        -webkit-box-shadow: 0 1px 0 1px #222 !important;\n        border-radius: 0 !important;\n        // background: #464f61 !important;\n        background: #2b313c !important;\n        cursor: pointer !important;\n        padding: 3px;\n      }\n\n      h3 {\n        padding: 5px;\n        color: orange;\n        background: #414651;\n      }\n\n      p {\n        padding: 5px 0;\n        min-height: 30px;\n      }\n    }\n  }\n\n}\n\n@primary-color: #1DA57A;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
